import { cloneDeep } from 'lodash'
import moment from 'moment'

export default function getAwardablePrintableBadgesFromSelection(reportData, selectedCells, teacherName) {
  const awardableBadges = []; // all badges in current selection eligible to be awarded
  const printableBadges = []; // all badges in current selection eligible to be printed
  
  for (const student of cloneDeep(reportData)) {
    const { studentId, badges } = student;
    const selectedBadgeTypes = selectedCells[studentId] || [];
    for (const badgeTypeId of selectedBadgeTypes) {
      const studentBadges = badges[badgeTypeId] || [];
      const printableBadge = studentBadges[0]
      if (printableBadge) {
        let { awardedAt, awarder } = printableBadge;
        if (!awarder) printableBadge.awarder = teacherName;
        if (!awardedAt) awardedAt = new Date();
        printableBadge.dateString = moment(awardedAt).format('LL');
        printableBadges.push(printableBadge);
      }
      for (const badge of studentBadges) {
        const { awarded } = badge;
        if (!awarded) awardableBadges.push(badge);
      }
    }
  }

  return { awardableBadges, printableBadges }
}